export const SET_RESEAUX = 'SET_RESEAUX';
export const SET_SHOW_RESEAUX = 'SET_SHOW_RESEAUX';
export const SET_DATE_DE_VISUALISATION = 'SET_DATE_DE_VISUALISATION';
export const SET_RESEAUX_WITH_FILTER = 'SET_RESEAUX_WITH_FILTER';
export const SET_ISOCHRONE = 'SET_ISOCHRONE';
export const SET_TYPE_LAYER_GEO_MARKETING = 'SET_TYPE_LAYER_GEO_MARKETING';
export const SET_MARKER_RESEAUX = 'SET_MARKER_RESEAUX';
export const SET_MARKER_FACES_DE_RESEAUX = 'SET_MARKER_FACES_DE_RESEAUX';
export const SET_ZOOM_CARTO_RESEAUX = 'SET_ZOOM_CARTO_RESEAUX';
export const SET_CRITERE_PLANNING_TEMPO = 'SET_CRITERE_PLANNING_TEMPO';
export const SET_DATA_PROPOSITION_TEMPO = 'SET_DATA_PROPOSITION_TEMPO';
export const SET_SELECTED_MARKER_FACES_DE_RESEAUX = 'SET_SELECTED_MARKER_FACES_DE_RESEAUX';
export const SET_SELECTED_MARKER_RESEAUX = 'SET_SELECTED_MARKER_RESEAUX';
export const SET_CENTER_RESEAUX = 'SET_CENTER_RESEAUX';
export const SET_RESEAUX_SELECTED = 'SET_RESEAUX_SELECTED';
export const SET_RESEAUX_SELECTED_INDICATOR = 'SET_RESEAUX_SELECTED_INDICATOR';
export const TRIE_RESEAUX = 'TRIE_RESEAUX';
export const SET_FILTER_VILLES_VENTES_RESEAUX = 'SET_FILTER_VILLES_VENTES_RESEAUX';
export const SET_FILTER_CHANGED = 'SET_FILTER_CHANGED';
export const ADD_FILTER_DYNAMIQUE = 'ADD_FILTER_DYNAMIQUE';
export const SELECT_FILTRE_DYNAMIQUE = 'SELECT_FILTRE_DYNAMIQUE';
export const ADD_FILTER_PROPERTY = 'ADD_FILTER_PROPERTY';
export const REMOVE_FILTER_PROPERTY = 'REMOVE_FILTER_PROPERTY';
export const REMOVE_FILTER = 'REMOVE_FILTER';
export const SET_AVEC_CONFRERES = 'SET_AVEC_CONFRERES';
export const SET_ACTIVE_TAB_RESEAU = 'SET_ACTIVE_TAB_RESEAU';
export const SET_ZOOM_MARKER = 'SET_ZOOM_MARKER';
export const SET_SHOW_RESEAUX_SELECTIONNE = 'SET_SHOW_RESEAUX_SELECTIONNE';
export const SET_AFFICHER_FACES_RESEAUX = 'SET_AFFICHER_FACES_RESEAUX';
export const SET_FILTRE_DISPO_RESEAU = 'SET_FILTRE_DISPO_RESEAU';
export const SET_DATA_PLANNING = 'SET_DATA_PLANNING';
export const SET_POINTS_ADDRESS = 'SET_POINTS_ADDRESS';
export const SET_FILTER_ADDRESS = 'SET_FILTER_ADDRESS';
export const SET_POSE_OPTION = 'SET_POSE_OPTION';
export const SET_AGENCES_SELECTIONNEES = 'SET_AGENCES_SELECTIONNEES';
export const SET_UPDATE_FILTRE = 'SET_UPDATE_FILTRE';



// WEBPACK FOOTER //
// ./src/store/creationOpportunite/venteReseauxTempo-mutation-type.js